import * as React from 'react';
import { useTranslations } from 'next-intl';
import { Box, type BoxT } from '../box';
import { TooltipControlled } from '../tooltip-legacy';

export interface CopyT extends Omit<BoxT, 'children'> {
  id: string;
  src: string;
  showSuccessTooltip?: boolean;
  tooltip?: string;
  children: (arg0: { copy: () => void }) => React.ReactNode;
}

export const Copy = ({
  id,
  src,
  showSuccessTooltip = true,
  tooltip,
  children,
  ...rest
}: CopyT) => {
  const t = useTranslations('ragnar.copy');
  const [show, setShow] = React.useState(false);

  const copyToClipboard = async () => {
    let failedToCopy = false;
    try {
      await navigator.clipboard.writeText(src);
    } catch (error) {
      failedToCopy = true;
    }

    if (showSuccessTooltip && !failedToCopy) {
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 2000);
    }
  };

  return (
    <>
      <TooltipControlled
        description={tooltip ?? t('copy_success_tooltip')}
        show={show}
        referenceId={id}
      />
      <Box id={id} {...rest}>
        {children({ copy: copyToClipboard })}
      </Box>
    </>
  );
};
